import { ButtonContainer } from 'src/components/Button/style/Button.style';
import FlowHeader from 'src/components/FlowHeader/FlowHeader.component';
import Loader from 'src/components/Loader/Loader.component';
import OtpForm from 'src/components/Otp/OtpForm.component';
import SubmitButton from 'src/components/SubmitButton/SubmitButton.component';
import Translate from 'src/components/Translate/Translate.component';
import { FormProps } from 'src/pages/registration/Registration.types';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { RoutePath } from 'src/routers/routers.config';
import {
  OtpTypeArray,
  VerifySignUpSessionOtpData,
  refreshSignUpSessionOtpMethodApi,
  verifySignUpSessionOtpMethodApi,
} from 'src/services/registration/registration.request';
import { useRegistrationStore } from 'src/store/store';
import { H4 } from 'src/style-utils/typographic';
import { FlowContainer } from 'src/style/Container.style';
import { formConfigRegistrationGuestStepOtpEmail } from './FormOtpEmail.helpers';
import { StyleSheetManager } from 'styled-components';
import { shouldForwardProp } from 'src/style-utils/functions';

const FormOtpEmail: React.FC<FormProps> = ({ nextPath, step, stepMax }) => {
  const sessionGuid: string = useRegistrationStore(
    (state) => state.sessionGuid,
  );
  const email: string = useRegistrationStore((state) => state.email);
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();
  const { initialValues, resolver } = formConfigRegistrationGuestStepOtpEmail();
  const methods = useForm({
    defaultValues: initialValues,
    resolver,
    mode: 'onChange',
  });

  const { mutate, isPending } = useMutation({
    mutationFn: (values: any) => verifySignUpSessionOtpMethodApi(values),
    onSuccess: (res) => {
      res.data.ResultSet
        ? navigate(nextPath)
        : setErrorMessage('error.otpNotMatching');
    },
    onError: (error: any) => {
      navigate(RoutePath.oops);
    },
  });

  const { mutate: mutateRefresh, isPending: isLoadingRefresh } = useMutation({
    mutationFn: refreshSignUpSessionOtpMethodApi,
    onSuccess: () => {
      methods.reset();
      setErrorMessage('');
    },
  });

  const onSubmit = async (data: any) => {
    const dataOtp: VerifySignUpSessionOtpData = {
      OtpType: OtpTypeArray.email,
      SessionGuid: sessionGuid,
      OtpValue: Object.values(data).join(''),
    };
    mutate(dataOtp);
  };

  if (isLoadingRefresh) {
    return <Loader overlayViewMode="fullscreen" active viewMode="fluid" />;
  }

  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <FlowHeader
        label="text.insertCodeLite"
        showWhiteSpaceRight
        stepNumber={step}
        stepMaxNumber={stepMax}
        showBackButton
        backButtonAction={() => navigate(-1)}
      />
      <FlowContainer>
        <H4 light>
          <Translate id="text.recoveryOtp" />
        </H4>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <OtpForm
              email={email}
              sendAgainHandler={() =>
                mutateRefresh({
                  OtpType: OtpTypeArray.email,
                  SessionGuid: sessionGuid,
                })
              }
              errorMessage={errorMessage}
              setErrorMessage={setErrorMessage}
              isLoadingRefresh={isLoadingRefresh}
            />
            <ButtonContainer>
              <SubmitButton minWidth="100%" disabled={isPending}>
                <Translate id="lbl.next" />
              </SubmitButton>
            </ButtonContainer>
          </form>
        </FormProvider>
      </FlowContainer>
    </StyleSheetManager>
  );
};

export default FormOtpEmail;
